import script from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=78f349e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f349e8"]])

export default __exports__